<template>
  <div id="app">
    <router-view />
    <WxOpenTip ref="wxTip" />
  </div>
</template>

<script>
import WxOpenTip from '@/components/WxOpenTip.vue'
import { isWechat, isMobile } from '@/utils/ua'
import { getToken } from '@/utils/auth'
import { getUserUniqueId } from '@/utils/uniqueId'

export default {
  components: { WxOpenTip },
  created() {
    if (isMobile() && isWechat()) {
      this.$nextTick(() => {
        this.$refs.wxTip && this.$refs.wxTip.show()
      })
    }
    if (getToken()) {
      this.$store.dispatch('GetInfo', getUserUniqueId()).catch(() => {})
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
html, body, h3 {
  margin: 0;
  padding: 0;
  height: 100%;
}
</style>
